import React from 'react';
import { useTheme } from '../../theme/ThemeProvider';

const ProtocolList = ({ protocols, onView, onEdit, onDelete, onDuplicate, loading }) => {
  const { mode } = useTheme();
  
  const styles = {
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
      gap: 'var(--spacing-lg)',
      marginTop: 'var(--spacing-lg)'
    },
    card: {
      backgroundColor: mode === 'dark' ? 'var(--dark-bg-secondary)' : 'var(--color-white)',
      borderRadius: 'var(--border-radius-lg)',
      padding: 'var(--spacing-lg)',
      border: `1px solid ${mode === 'dark' ? 'var(--dark-border-primary)' : 'var(--color-light-gray)'}`,
      boxShadow: mode === 'dark' ? 'var(--dark-shadow-md)' : 'var(--shadow-md)',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: mode === 'dark' ? 'var(--dark-shadow-lg)' : 'var(--shadow-lg)'
      }
    },
    icon: {
      fontSize: 'var(--font-size-3xl)',
      marginBottom: 'var(--spacing-sm)'
    },
    title: {
      fontSize: 'var(--font-size-lg)',
      fontWeight: 'var(--font-weight-semibold)',
      color: mode === 'dark' ? 'var(--dark-text-primary)' : 'var(--color-black)',
      marginBottom: 'var(--spacing-sm)',
      wordBreak: 'break-word'
    },
    description: {
      fontSize: 'var(--font-size-sm)',
      color: mode === 'dark' ? 'var(--dark-text-tertiary)' : 'var(--color-medium-gray)',
      marginBottom: 'var(--spacing-md)',
      lineHeight: 1.5,
      minHeight: '40px'
    },
    meta: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--spacing-xs)',
      fontSize: 'var(--font-size-sm)',
      color: mode === 'dark' ? 'var(--dark-text-tertiary)' : 'var(--color-medium-gray)',
      marginTop: 'var(--spacing-md)',
      paddingTop: 'var(--spacing-md)',
      borderTop: `1px solid ${mode === 'dark' ? 'var(--dark-border-primary)' : 'var(--color-light-gray)'}`
    },
    badge: {
      display: 'inline-block',
      padding: 'var(--spacing-xs) var(--spacing-sm)',
      backgroundColor: mode === 'dark' ? 'rgba(41, 181, 232, 0.2)' : 'rgba(41, 181, 232, 0.1)',
      color: '#29B5E8',
      borderRadius: 'var(--border-radius-sm)',
      fontSize: 'var(--font-size-xs)',
      fontWeight: 'var(--font-weight-semibold)',
      marginRight: 'var(--spacing-xs)'
    },
    actions: {
      display: 'flex',
      gap: 'var(--spacing-sm)',
      marginTop: 'var(--spacing-md)'
    }
  };
  
  return (
    <div style={styles.grid}>
      {protocols.map((protocol) => {
        const layoutElements = protocol.layout_config?.elements || [];
        const sourceCount = protocol.data_source_ids?.length || 0;
        
        return (
          <div 
            key={protocol.id}
            style={styles.card}
          >
            <div style={styles.icon}>📊</div>
            
            <h3 style={styles.title}>{protocol.name}</h3>
            
            <p style={styles.description}>
              {protocol.description || 'Sin descripción'}
            </p>
            
            <div>
              <span style={styles.badge}>
                {layoutElements.length} {layoutElements.length === 1 ? 'elemento' : 'elementos'}
              </span>
              <span style={styles.badge}>
                {sourceCount} {sourceCount === 1 ? 'fuente' : 'fuentes'}
              </span>
            </div>
            
            <div style={styles.meta}>
              <div>👤 <strong>Creado por:</strong> {protocol.created_by_username}</div>
              <div>📅 <strong>Creado:</strong> {new Date(protocol.created_at).toLocaleDateString()}</div>
              <div>🔄 <strong>Actualizado:</strong> {new Date(protocol.updated_at).toLocaleDateString()}</div>
            </div>
            
            <div style={styles.actions}>
              <button
                className="btn btn-primary"
                onClick={() => onView(protocol)}
                disabled={loading}
                style={{ flex: 1 }}
                title="Ver protocolo"
              >
                👁️ Ver
              </button>
              <button
                className="btn btn-secondary"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(protocol);
                }}
                disabled={loading}
                title="Editar protocolo"
                style={{ padding: 'var(--spacing-sm)' }}
              >
                ✏️
              </button>
              <button
                className="btn btn-secondary"
                onClick={(e) => {
                  e.stopPropagation();
                  onDuplicate(protocol.id);
                }}
                disabled={loading}
                title="Duplicar protocolo"
                style={{ padding: 'var(--spacing-sm)' }}
              >
                📋
              </button>
              <button
                className="btn btn-ghost"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(protocol.id);
                }}
                disabled={loading}
                style={{ color: '#FF6B35', padding: 'var(--spacing-sm)' }}
                title="Eliminar protocolo"
              >
                🗑️
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProtocolList;

